import React from "react";

export default function ViewScannerDetails({ data }) {
  if (!data) return null;

  return (
    <div className="flex flex-col gap-6 divide-y divide-gray-100 text-sm view-card">
      {/* SECTION 1: SCANNER PERSONAL DETAILS */}
      <div className="space-y-4 pt-1">
        <div className="view-subtitle ">
          <span>Scanner Details</span>
        </div>

        <div className="space-y-3 ">
          <div>
            <p className="view-label">Full Name</p>
            <p className="view-value font-semibold">
              {data.firstName} {data.lastName}
            </p>
          </div>

          <div>
            <p className="view-label">Email Address</p>
            <p className="view-value">{data.email || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">CNP (Cod Numberic Personal)</p>
            <p className="view-value">{data.cnp || "N/A"}</p>
          </div>
        </div>
      </div>

      {/* SECTION 2: ACCESS & SECURITY DETAILS */}
      <div className="space-y-4 pt-5">
        <div className="view-subtitle">
          <span>Security & Status</span>
        </div>

        <div className="grid grid-cols-2 gap-4 ">
          <div>
            <p className="view-label">Login Code</p>
            <p className="view-value">{data.loginCode || data.code || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Status</p>
            <div className="mt-1">
              <span
                className={`inline-block rounded-full px-3 py-0.5 text-xs font-semibold ${
                  data.status === "Active" || data.isActive
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {data.status || "Active"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 3: LOCATION & GATE */}
      <div className="space-y-4 pt-5">
        <div className="view-subtitle">
          <span>Location Details</span>
        </div>

        <div className="grid grid-cols-2 gap-4 ">
          <div>
            <p className="view-label">Country</p>
            <p className="view-value">{data.country || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Zip / Postal Code</p>
            <p className="view-value">{data.postalCode || "N/A"}</p>
          </div>

          <div className="col-span-2">
            <p className="view-label">Gate / Location</p>
            <p className="view-value">
              {data.gateNumber || data.gate || "N/A"}
            </p>
          </div>
        </div>
      </div>

      {/* SECTION 4: CONTACT INFO */}
      <div className="space-y-4 pt-5">
        <div className=" view-subtitle">
          <span>Contact Information</span>
        </div>

        <div className="grid grid-cols-2 gap-4 ">
          <div>
            <p className="view-label">Phone Country Code</p>
            <p className="view-value">{data.phoneCountryCode || "+40"}</p>
          </div>

          <div>
            <p className="view-label">Phone Number</p>
            <p className="view-value">{data.phoneNumber || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
